<template>
  <Mall3dIcon :src="basketImage" :size="size" :screenOpacity="0.8" />
</template>

<script>
import Mall3dIcon from '@/components/new/atoms/Mall3dIcon.vue'

export default {
  name: 'MallBasketIcon',
  components: {
    Mall3dIcon,
  },
  props: {
    size: {
      type: Number,
      default: 100,
    },
  },
  data() {
    return {
      basketImage: require('@/assets/mall/img_basket_3d.png'),
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/new/atoms/MallBasketIcon.vue